import { Typography } from '@material-ui/core';
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { AdultSliderCont, PlayingAgeCont, StyledRangeSlider } from './GeneralAppearance.styles';

interface Props {
  birth: {
    day: string;
    month: string;
    year: string;
  };
  val: number[] | null;
  setVal: (number: number[]) => void;
  slim?: boolean;
}

const MinorSlider: React.FC<Props> = ({ birth, val, setVal, slim }) => {
  const [defaultVal, setdefaultVal] = useState([8, 12]);
  const [marks, setmarks] = useState([]);
  const [age, setage] = useState<number>(0);
  const [monthsOld, setmonthsOld] = useState(12);
  const [firstLoad, setFirstLoad] = useState(true);

  const handleChange = (e: any, n: any) => {
    if (val === null) return;
    const min = n[0],
      max = n[1];

    if (min === val[0] && max === val[1]) return;
    setVal([min, max]);
  };

  const getAllowance = (age: number) => {
    if (age >= 2 && age <= 5) {
      return 1;
    } else if (age >= 6 && age <= 10) {
      return 2;
    }
    return 3;
  };

  useEffect(() => {
    if (!birth.day) return;
    const birthString = birth.year + '-' + birth.month + '-' + birth.day;
    console.log('birthString', birthString);

    const birthMoment = moment(birthString);
    const now = moment(new Date());
    const duration = now.diff(birthMoment, 'year');

    const allowance = getAllowance(duration);

    const min = duration - allowance;
    const max = duration + allowance;

    if ((!val || age !== duration) && !firstLoad) {
      if (allowance === 1) {
        setVal([min, max]);
      } else {
        setVal([min + 1, max - 1]);
      }
    }
    setFirstLoad(false);

    setage(duration || 0);

    if (duration <= 1) {
      setmonthsOld(now.diff(birthMoment, 'month'));
    }
  }, [birth]);

  useEffect(() => {
    if (age === null) return;
    const allowance = getAllowance(age);

    const min = age - allowance;
    const max = age + allowance;

    setdefaultVal([min, max]);

    const newMark: any = [];

    for (let i = min; i <= max; i++) {
      newMark.push({
        value: i,
        label: i === age ? `${age} your age` : i.toString(),
      });
    }

    setmarks(newMark);
  }, [age]);

  const renderPlayRange = () => {
    if (age <= 1) {
      return `${monthsOld < 1 ? 0 : monthsOld} ${monthsOld < 2 ? 'month' : 'months'} old`;
    } else {
      return val && `${val[0]} - ${val[1]} years old`;
    }
  };

  return (
    <AdultSliderCont style={{ margin: age && age > 1 ? '20px 0 60px 0' : '20px 0 0 0' }} slim={slim}>
      <PlayingAgeCont style={{ flexDirection: slim ? 'column' : 'unset' }}>
        <Typography style={{ marginRight: 7 }}>{age && age > 1 ? 'Playing Age Range:' : 'Actual Age:'}</Typography>
        <Typography color="primary">{renderPlayRange()}</Typography>
      </PlayingAgeCont>
      {age > 1 ? (
        <StyledRangeSlider
          max={defaultVal[1]}
          min={defaultVal[0]}
          track="normal"
          value={val || [0, 1]}
          marks={marks}
          //   defaultValue={defaultVal}
          onChange={handleChange as any}
          orientation={slim ? 'vertical' : 'horizontal'}
        />
      ) : (
        <React.Fragment />
      )}
    </AdultSliderCont>
  );
};

export default MinorSlider;
